
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SearchAdvertsListItemStub extends Vue {}
